export enum DocumentsTypes {
    GET_DOCUMENTS_LIST = '@documents/GET_DOCUMENTS_LIST',
    REQUEST_GET_DOCUMENTS_LIST = '@documents/REQUEST_GET_DOCUMENTS_LIST',
    SAVE_DOCUMENT = '@documents/SAVE_DOCUMENT',
    REQUEST_SAVE_DOCUMENT = '@documents/REQUEST_SAVE_DOCUMENT',
}

export type Document = {
    id: string;
    text: Record<string, string>;
    publishDate: Date;
    type: string;
};

export type DocumentsState = {
    isLoading: boolean;
    documents: Document[];
};

export type DocumentsAction<Payload> = {
    type: DocumentsTypes;
    payload: Payload;
};

export type DocumentsReducer = (state: DocumentsState, actions: DocumentsAction<DocumentsState>) => DocumentsState;
